/* eslint-disable */
<template>
  <div id="comments" class="newhomeworkCorrecting">
    <div class="topTitle">
      <p class="return" @click="goBack">
        <span style="width:100px;display:inline-block">
          <a-icon type="arrow-left" style="margin-right:10px" />返回
        </span>
      </p>
      <p class="name">
        <span class="caret-right-box">{{ $route.query.title }}</span>
        <span class="handWritingLoading-box">
          <i class="handWritingLoading" style="color:#409eff;">(笔迹加载中...)</i>
        </span>
      </p>
      <p class="changeZoom" @click="changeZoom()">
        <span v-if="!isFullDisplay">全屏显示</span>
        <span v-else>退出全屏</span>
      </p>
      <p class="classManage" @click="classManage()">班级管控</p>
      <p class="quickNavigation" @click="showDrawer()">试题导航</p>
      <!-- <p class="classManage" @click="viewMicrolesson()" style="width:150px;">
        
        <a-select
              placeholder="微课列表"
              v-if="microlessonList.length != 0"
             
              style="width:100%"
              
            >
              <a-select-option
                v-for="(item, index) in microlessonList"
                :key="index"
                :value="item.name"
                @click="changeMicrolesson(item)"
              >
                <span>{{ item.name }}</span>
              </a-select-option>
            </a-select>
      </p> -->
    </div>
    <!-- 固定头部 -->
    <!-- <div class="page-header" style="border-bottom-width:2px">
      <span class="page-header-item" @click="goBack()">
        <a-icon type="arrow-left" />
        <span>
          返回
        </span>
      </span>
      <span
        class="page-header-item page-header-item-2"
        style="min-width:240px;justify-content:left"
      >
        <span @click="goHome()">
          <a-icon type="home" />
          <i>&nbsp;主页&nbsp;</i>
        </span>
        <span class="caret-right-box">
          <a-icon type="caret-right" />
          <i>&nbsp;{{ $route.query.title }}</i>
        </span>
        <span class="handWritingLoading-box">
          <i class="handWritingLoading" style="color:#409eff;"
            >(笔迹加载中...)</i
          >
        </span>
      </span>
      <span class="page-header-item">
        <span @click="showDrawer()" class="quickNavigation">快捷导航</span>
      </span>
    </div>-->

    <div class="main">
      <div class="content">
        <!-- 分为客观题和主观题 -->
        <div class="answer-info" style="padding: 10px;height: 100%;" v-if="stem.objective">
          <div>得分率：{{ scoreRate }}%</div>
          <template v-for="(subItem, subIndex) in optionAnswerList" v-cloak>
            <div class="current-answer" v-if="subItem.subQuIndex == subOptionIndex" :key="subIndex">
              <div v-for="referAnswerItem in referAnswerList" :key="referAnswerItem.subQuIndex">
                <template v-if="referAnswerItem.subQuIndex == subOptionIndex">
                  <a-popover
                    arrowPointAtCenter
                    trigger="click"
                    placement="right"
                    v-for="(optionItem,
                    optionIndex) in subItem.optionAnswerList"
                    :key="optionIndex"
                  >
                    <template slot="title">
                      <div style="padding: 6px 0">
                        参考答案：
                        <span style="font-weight: 700">
                          {{
                          referAnswerItem.referAnswer
                          }}
                        </span>
                      </div>
                    </template>
                    <template slot="content">
                      <p style="margin-bottom:8px">
                        选择选项
                        <i style="font-weight: 700">{{ optionItem.option }}</i>
                        的同学有：
                      </p>
                      <div v-if="optionItem.counts > 0">
                        <p
                          style="
                            max-width: 400px;
                            display: flex;
                            justify-content: start;
                            align-items: center;
                            flex-wrap: wrap;
                          "
                        >
                          <span
                            v-for="(studentItem,
                            studentIndex) in optionItem.stuName"
                            :key="studentIndex"
                            :style="
                              referAnswerItem.referAnswer == optionItem.option
                                ? 'color:#409eff;border:1px solid #409eff;'
                                : 'color:#e4393c;border:1px solid #e4393c;'
                            "
                            style="
                              padding: 5px 10px;
                              margin: 0 5px 5px 0;
                              border-radius: 3px;
                            "
                          >{{ studentItem }}</span>
                        </p>
                      </div>
                      <div v-else style="width: 400px">无</div>
                    </template>

                    <div v-if="!answerChange" class="option">
                      <div class="option-answer">{{ optionItem.option }}</div>
                      <div>{{ optionItem.counts }} / 人</div>
                    </div>
                    <div
                      v-else
                      class="option"
                      :style="
                        referAnswerItem.referAnswer == optionItem.option
                          ? 'background-color:#67c23a'
                          : 'background-color:#e4393c'
                      "
                    >
                      <div class="option-answer">{{ optionItem.option }}</div>
                      <div>{{ optionItem.counts }} / 人</div>
                    </div>
                  </a-popover>
                </template>
              </div>
            </div>
          </template>
        </div>
        <!-- 左边 -->
        <div class="answer-info" v-else>
          <div
            class="student-info"
            @click="currentStem(-1)"
            :class="currentStudentIndex == -1 ? 'currentStudent' : ''"
            :style="
              currentStudentIndex == -1
                ? 'background-color:#1890ff;color:#fff'
                : 'background-color:#fff;color:#000'
            "
          >得分率：{{ scoreRate }}%</div>
          <div
            :class="currentStudentIndex == studentIndex ? 'currentStudent' : ''"
            class="student-info"
            v-for="(studentItem, studentIndex) in studentQuestList"
            :key="studentIndex"
            @click="currentStudentHandle(studentItem, studentIndex)"
          >
            <span>
              <img
                v-if="studentItem.questStatus == 1"
                src="../../assets/images/noSubmit.png"
                :style="
                  $parent.windowWidth > 1200 ? 'width:22px' : 'width:15px'
                "
              />
              <img
                v-if="studentItem.questStatus == 2"
                src="../../assets/images/noCorrect.png"
                :style="
                  $parent.windowWidth > 1200 ? 'width:22px' : 'width:15px'
                "
              />
              <img
                v-if="studentItem.questStatus == 3"
                src="../../assets/images/right.png"
                :style="
                  $parent.windowWidth > 1200 ? 'width:22px' : 'width:15px'
                "
              />
              <img
                v-else-if="studentItem.questStatus == 4"
                :style="
                  $parent.windowWidth > 1200 ? 'width:22px' : 'width:15px'
                "
                src="../../assets/images/wrong.png"
              />
              <img
                v-else-if="studentItem.questStatus == 5"
                :style="
                  $parent.windowWidth > 1200 ? 'width:22px' : 'width:15px'
                "
                src="../../assets/images/halfRight.png"
              />
            </span>
            <span>{{ studentItem.stuName }}</span>
            <i v-if="currentStudentIndex == studentIndex">◀</i>
          </div>
        </div>

        <!-- 试题内容区域 -->
        <div class="stem-info">
          <template v-for="(item, index) in questionList">
            <div class="stem-box" v-if="item.questIndex == questIndex" :key="index" ref="stemBox">
              <!-- <div class="sq-num">{{ item.questIndex + 1 }}、</div> -->
              <!-- v-show="item.questIndex == questIndex" -->
              <div
                class="quescontent"
                :initindex="item.questIndex"
                :objective="item.objective + ''"
                :questionTypeName="item.typeName"
              >
                <div class="stem child" ref="addImage" v-cloak v-html="item.stem"></div>

                <span class="lattice_bg10" style="display:none">
                  <img src="@/assets/images/exercise-app-bg12.png" alt srcset />
                </span>
              </div>

              <canvas
                class="mycanvas"
                ref="mycanvas"
                :id="'canvas-' + (item.questIndex + 1)"
                style="touch-action:pan-y"
              ></canvas>
            </div>
          </template>
        </div>

        <!-- 工具栏 -->
        <div class="utils">
          <button
            class="iconfont icon-Arrow_left"
            :disabled="questIndex == 0 ? true : false"
            v-preventReClick
            @click="prevQuestion()"
            title="上一题"
          ></button>
          <button
            class="iconfont icon-Arrow_Right"
            v-preventReClick
            @click="nextQuestion()"
            title="下一题"
          ></button>
          <button
            class="iconfont icon-yincang"
            v-if="answerChange"
            @click="lookAnswer()"
            title="隐藏答案"
          ></button>
          <button class="iconfont icon-chakan1" v-else @click="lookAnswer()" title="查看答案"></button>
          <button class="iconfont icon-Delete" @click="deleteDrawing()" title="清空笔迹"></button>
          <button class="iconfont icon-chexiao1" v-if="drawing" @click="rubbeHandle()" title="撤销笔迹"></button>
          <!-- <button class="iconfont icon-Add" v-preventReClick @click="addPages()" title="加书写区"></button> -->
          <span v-if="showHandWriting" class="iconfont handwriting" @click="handWriting()">
            <img v-if="handWritingFlag" src="../../assets/images/handwriting1.png" title="隐藏笔迹" />
            <img
              v-else-if="!handWritingFlag"
              src="../../assets/images/handwriting.png"
              title="显示笔迹"
            />
          </span>
          <span v-else class="iconfont handwriting">&nbsp;</span>
        </div>
      </div>
    </div>

    <!-- 答案 -->
    <a-modal
      :maskStyle="{
        'background-color': 'rgba(0,0,0,.5)',
      }"
      :zIndex="1999"
      centered
      :footer="null"
      :visible="visible"
      @cancel="oncancel"
      :width="$parent.windowWidth > 1200 ? 920 : 720"
    >
      <template slot="title">
        <div class="modal-title">参考答案</div>
      </template>
      <div class="rightAnswer">
        <div v-cloak v-html="stem.answer"></div>
      </div>
    </a-modal>

    <!-- 抽屉 -->
    <a-drawer
      v-if="destroyConponents"
      :title="$route.query.title"
      placement="right"
      :closable="false"
      :zIndex="2999"
      :width="$parent.windowWidth > 1200 ? 600 : 450"
      :visible="drawerVisible"
      @close="onClose"
    >
    <div><span @click="questionListSort('id')" style="cursor:pointer;">按题号排序</span>
      &nbsp;|&nbsp;
      <span @click="questionListSort('score')" style="cursor:pointer;">按得分率排序</span></div>
      <lazy-component
        v-for="(item, index) in questionList"
        :key="index"
        class="drawerQuestion"
        @show="handler($event, item)"
      >
        <div>{{ item.questIndex + 1 }}、</div>
        <div @click="jumpHandle(item, item.questIndex)">
          <span
            class="objectiveQuestion"
            v-if="item.objective == false && item.rightRates[0].rightRate > -1"
          >
          <span
              class="rightRate"
              :class="getColor(item.rightRates[0].rightRate * 100)"
            >{{ (item.rightRates[0].scoreRate?item.rightRates[0].scoreRate * 100:0).toFixed(0) }}%</span>
          </span>
          <span
            v-else-if="
              item.objective == false && item.rightRates[0].rightRate == -1
            "
            class="bg_gray rightRate"
          >未批改</span>
          <span
            v-else-if="item.objective == true && item.rightRates.length > 0"
            class="objectiveQuestion"
          >
            <template v-for="ele in item.rightRates">
              <span :key="ele.bankIndex">
                <i
                  v-if="ele.rightRate > -1"
                  :class="getColor(ele.rightRate * 100)"
                  class="rightRate"
                >{{ (ele.scoreRate?ele.scoreRate * 100:0).toFixed(0) }}%</i>
                <i v-else class="bg_gray rightRate">未批改</i>
              </span>
            </template>
          </span>
          <span v-else class="bg_gray rightRate">未批改</span>
        </div>
      </lazy-component>
    </a-drawer>
    
    <!-- 图片加载图标 -->
    <div class="spinner" v-if="spinner">
      <van-loading size="50px" style="color: #409eff" type="spinner" />
    </div>
  </div>
</template>

<script>
import SignaturePad from "@/assets/js/signature_pad"
let word = 200 //作文题的最大字数
export default {
  data () {
    return {
      signaturePad: null,
      config: {
        zoom: 1, //设置笔迹点缩放比例
        penColor: "red", //笔刷颜色
        allowType: "mouse", //允许pointerType mouse/pen/touch/‘’ default ''
        minWidth: 0.5, //最小宽度
        maxWidth: 1.5, //最大宽度
        throttle: 16, //每秒绘制的次数
        drawing: true, //控制工具栏的变量
      },

      scoreRate:0,//全班该题的得分率
      rightRate:0,//全部该题的完对率

      studentQuestList: [],
      optionAnswerList: [],
      referAnswerList: [],
      questIndex: this.$route.query.questIndex
        ? parseInt(this.$route.query.questIndex)
        : 0,
      questionList: [],
      subOptionIndex: "0",
      answerChange: false,
      toggleQuestion: false,
      visible: false,
      currentStudentIndex: -1,
      studentid: "",
      studentImg: [],
      teacherImg: [],
      zoom: 1,
      zoom1: 1,
      drawing: true,
      imgShow: false,
      oldScrollTop: 0, //记录上一次滚动结束后的滚动距离
      newScrollTop: 0, // 记录当前的滚动距离
      spinner: false,
      oldStudentId: "",
      drawerVisible: false,
      getColor (val) {
        if (val >= 90) {
          return "bg_blue"
        } else if (val >= 80) {
          return "bg_green"
        } else if (val >= 70) {
          return "bg_orange"
        } else if (val >= 60) {
          return "bg_purple"
        } else if (val < 60) {
          return "bg_red"
        }
      },
      getColor1 (val) {
        if (val == 4) {
          return "bg_red"
        } else if (val == 3) {
          return "bg_green"
        } else if (val == 2) {
          return "bg_orange"
        } else if (val == 1) {
          return "bg_gray"
        }
      },
      timer: null,
      EL: {
        start_page: 0,
        page_count: 0,
        max_pages: 200,
      },
      handWritingFlag: false,
      saveFlag: false,
      saveflag1: false,
      loading: false,
      showHandWriting: false, // 是否显示备课笔迹的按钮
      stem: {},
      blankAnswerList: [],
      destroyConponents: true,
      isFullDisplay: false,//是否全屏模式
      microlessonList:[],//微课列表
      trajectoryDataPen:null,//笔轨迹信息
      trajectoryDataEraser:null,//橡皮擦轨迹信息
      canvasWidthPen:0,
      canvasHeightPen:0,
      canvasWidthEraser:0,
      canvasHeightEraser:0,
      videoUrl:null,
      amrTime:null,
      amrData:null,
    }
  },
  methods: {
    // 获取微课列表数据
    async getMicrolesson(){
      console.log('打印题号======',this.stem)
      const { data: res } = await this.$http.post(
        `v1/microlesson/getQuestionMicrolessonList`,
          {
            exerciseId: this.$route.query.exerciseId,
            questionId: this.$route.query.questionId,
          }
      )
      if(res.code == 200){
        this.microlessonList=res.data
      }else{
        this.$message.warn(res.message, 1)
      }
      console.log('打印微课列表==============',res)
    },
    // 选择微课列表
    async changeMicrolesson(item){
      let routeUrl = this.$router.resolve({
          path: "/viewMicrolesson",
          query: {smicrolessonId: item.smicrolessonId}
        });
        window.open(routeUrl.href, '_blank')
          
    },
    // 返回主页
    goHome () {
      this.$router.push("/")
      this.saveHandWriting()
    },
    // 返回上一步
    goBack () {
      if (this.isFullDisplay) {
        this.changeZoom()
      }
      this.$router.go(-1)
      this.saveHandWriting()
    },

    currentStem (studentIndex) {
      var self = this
      self.currentStudentIndex = studentIndex
      self.handWritingFlag = false
      self.studentImg = []
      self.teacherImg = []
      $(".bk-mode-4").val("")
      $(".bk-mode-4")
        .siblings()
        .remove()
      // self.signaturePad.clear()
      $(".quescontent")
        .find(".stuImg")
        .remove()
      $(".quescontent")
        .find(".teaImg")
        .remove()
      self.oldStudentId = ""
      $(".quescontent").each(function () {
        self.getNewElHeight($($(this)))
      })
      this.getHandWriting()
    },

    // 获取题目详细信息
    async getQuestionInfo () {
      const { data: res } = await this.$http.get(
        `v1/learnonly/exercise/exerciseQuestion?`,
        {
          params: {
            exerciseId: this.$route.query.exerciseId,
            classId: this.$route.query.classId,
            questionId: this.stem.questionId,
            objective: this.stem.objective,
          },
        }
      )
      // console.log(res)
      if (res.code != 200) return this.$message.error(`获取题目数据失败`, 1)

      this.scoreRate = Number(res.data.scoreRate).toFixed(0)//全班该题的得分率
      this.rightRate = Number(res.data.rightRate).toFixed(0)//全班该题的完对率

      this.studentQuestList = res.data.studentQuestList
      this.optionAnswerList = res.data.optionsList
      this.referAnswerList = res.data.referAnswerList

      this.$nextTick(() => {
        this.handle1()
      })
      // if (this.studentQuestList.length > 0) {
      //   this.studentid = this.studentQuestList[0].studentId
      //   this.getStudentImg()
      // }
    },

    handle1 () {
      for (let j = 0; j < this.referAnswerList.length; j++) {
        for (let i = 0; i < this.stem.rightRates.length; i++) {
          if (
            this.stem.rightRates[i].bankIndex ==
            this.referAnswerList[j].subQuIndex
          ) {
            this.referAnswerList[j].scoreRate = this.stem.rightRates[
              i
            ].scoreRate
          }
        }
      }
      let bkBoxList = $(".stem-box")
        .find(".bk-box")
        .toArray()
      if (bkBoxList.length > 0) {
        for (let m = 0; m < bkBoxList.length; m++) {
          for (let n = 0; n < this.referAnswerList.length; n++) {
            if (this.referAnswerList[n].subQuIndex == m) {
              $(bkBoxList[m]).attr(
                "sub-index",
                this.referAnswerList[n].subQuIndex
              )
              if (this.answerChange) {
                $(bkBoxList[m])
                  .find(".bk")
                  .text(this.referAnswerList[n].referAnswer)
                if (this.referAnswerList[n].scoreRate >= 0) {
                  var scoreRate =
                    (this.referAnswerList[n].scoreRate * 100).toFixed(0) + "%"
                    
                  var rightRateDiv = $('<i class="rightRate"></i>')
                  rightRateDiv.text(scoreRate)
                  rightRateDiv.addClass(
                    this.getColor(this.referAnswerList[n].scoreRate * 100)
                  )
                  $(bkBoxList[m]).append(rightRateDiv)
                }
              } else {
                $(bkBoxList[m])
                  .find(".bk")
                  .text("")
                $(bkBoxList[m])
                  .find(".rightRate")
                  .remove()
              }
            }
          }
        }
      }
    },

    // 查看答案
    lookAnswer () {
      // 主观题显示弹框
      if (this.stem.objective == false) {
        this.visible = true
      } else {
        // 客观题
        this.answerChange = !this.answerChange
        this.handle1()
      }
    },

    // 上一题
    prevQuestion () {
      if (this.currentStudentIndex != -1) {
        this.saveFlag = false
      }
      this.saveHandWriting()
      $(".stem-info").animate({ scrollTop: 0 }, 0)
      if (this.questIndex == 0) return
      this.questIndex -= 1
      this.stem = this.questionList[this.questIndex]

      this.answerChange = false

      this.toggleQuestion = true
      this.subOptionIndex = "0"
      this.studentImg = []
      this.currentStudentIndex = -1
      this.oldStudentId = ""
      this.getQuestionInfo()

      // 初始化调用绘制canvas
      setTimeout(() => {
        this.drawing = true
        this.Redraw()
      }, 0)
      this.selectOption()
    },

    // 下一题
    nextQuestion () {
      $(".stem-info").animate({ scrollTop: 0 }, 0)
      if (this.questIndex == this.questionList.length - 1) return
      if (this.currentStudentIndex != -1) {
        this.saveFlag = false
      }
      this.saveHandWriting()
      this.questIndex += 1
      // 初始化值并重新渲染
      this.stem = this.questionList[this.questIndex]
      // console.log(this.stem)
      // 不是主观题的时候重置查看答案的默认值

      this.answerChange = false

      this.toggleQuestion = true
      this.subOptionIndex = "0"
      this.currentStudentIndex = -1
      this.studentImg = []
      this.oldStudentId = ""
      this.getQuestionInfo()

      // 初始化调用绘制canvas
      setTimeout(() => {
        this.drawing = true
        this.Redraw()
      }, 0)
      this.selectOption()
    },

    oncancel () {
      this.visible = false
      this.answerChange = false
    },

    // 手动加页
    addPages () {

      this.$nextTick(() => {
        console.log('===1', $("body"))
        console.log('==2', $(".page-header"))
        var page = $("<div class='addPages'></div>")
        let height =
          ($("body")[0].offsetHeight - $(".page-header")['prevObject'][0].offsetHeight - 1) /
          this.zoom
        page.css({
          width: "100%",
          height: height,
          borderTop: "1px dashed #eee",
        })
        $(".stem-box").append(page)
        $(".mycanvas")[0].height = $(".stem-box").height()
        this.signaturePad.fromData(this.signaturePad._data)
      })

    },

    // 备课笔记
    handWriting () {
      console.log("备课笔记")
      console.log(this.handWritingFlag)
      if (this.currentStudentIndex == -1) {
        if (this.handWritingFlag) {
          this.saveflag1 = true
          this.saveHandWriting()
          this.signaturePad.clear()
          this.handWritingFlag = !this.handWritingFlag
        } else {
          this.saveflag1 = false
          this.getHandWriting()
        }
      }
    },

    // 获取备课笔记
    async getHandWriting () {
      $(".handWritingLoading").fadeIn(50)
      const { data: res } = await this.$http.get(
        `v1/learnonly/exercise/question/explain?exerciseId=${this.$route.query.exerciseId
        }&teacherId=${this.$store.getters.id}&classId=${this.$route.query.classId
        }&questionId=${this.stem.questionId}`
      )
      console.log("getHandWriting", res)
      if (res.code != 200) return this.$message.error(res.message, 1)
      // console.log(Object.keys(res.data).length)
      if (
        Object.keys(res.data).length == 0 ||
        JSON.parse(res.data.datajson).length == 0
      ) {
        this.saveflag1 = false
        this.handWritingFlag = false
        this.showHandWriting = false
        $(".handWritingLoading").fadeOut(500)
        return
      } else {
        this.showHandWriting = true
        this.handWritingFlag = true
        this.signaturePad._data = res.data.datajson
          ? JSON.parse(res.data.datajson)
          : []
        if ($(".mycanvas")[0].height == res.data.height) {
          this.signaturePad.fromData(this.signaturePad._data)
          $(".handWritingLoading").fadeOut(500)
        } else {
          $(".mycanvas")[0].style.height = res.data.height
          $(".mycanvas")[0].height = res.data.height
          this.signaturePad.fromData(this.signaturePad._data)
          $(".handWritingLoading").fadeOut(500)
        }
      }
    },

    // 保存备课笔记
    async saveHandWriting () {
      if (this.saveflag1 && !this.handWritingFlag) return
      if (this.saveFlag) {
        console.log("保存备课笔记")
        let width = $(".mycanvas").width()
        let height = $(".mycanvas").height()
        const { data: res } = await this.$http.post(
          `v1/learnonly/exercise/save/question/explain`,
          {
            exerciseId: this.$route.query.exerciseId,
            classId: this.$route.query.classId,
            questionId: this.stem.questionId,
            dataJson: JSON.stringify(this.signaturePad._data),
            width: Math.floor(width),
            height: Math.floor(height),
          }
        )
        console.log(res)
        if (res.code != 200) return this.$message.error("备课笔记保存失败", 1)
      }
    },

    // 自定义指令,监听盒子的宽高
    resize () {
      let self = this
      var h = $(".stem-box").height()
      var w = $(".stem-box").width()
      var stemInfoH = $(".stem-info").height()
      var canvas = $(".mycanvas")[0]
      if (canvas) {
        if (self.signaturePad) {
          canvas.width = w
          if (h < stemInfoH) {
            canvas.height = stemInfoH
          } else {
            canvas.height = h
          }
          self.signaturePad.fromData(self.signaturePad._data)
        }
      }

      // ===================================================================
      // console.time("resize耗时")
      // let self = this
      // var h = $(".stem-box").height()
      // var w = $(".stem-box").width()
      // var canvas = $(".mycanvas")[0]
      // // console.log(canvas)
      // if (canvas) {
      //   var cxt = canvas.getContext("2d")
      //   // var imgData = cxt.getImageData(0, 0, canvas.width, canvas.height)
      //   // canvas.width = w
      //   // canvas.height = h
      //   // cxt.putImageData(imgData, 0, 0)

      //   var nc = document.createElement("canvas")
      //   nc.width = canvas.width
      //   nc.height = canvas.height
      //   nc.getContext("2d").drawImage(canvas, 0, 0)

      //   if (h < $(".stem-info").height()) {
      //     canvas.height = $(".stem-info").height()
      //     nc.height = $(".stem-info").height()
      //   } else {
      //     canvas.height = h
      //   }
      //   canvas.width = w
      //   if (self.signaturePad) {
      //     console.time("resize111耗时")
      //     self.signaturePad.fromData(self.signaturePad._data)
      //     console.timeEnd("resize111耗时")
      //   }
      //   // 利用canvas的css样式来解决canvas的高度增加笔迹下拉的问题
      //   $(".mycanvas").css({
      //     "padding-bottom": "0",
      //   })
      //   console.time("resize111221耗时")
      //   cxt.drawImage(nc, 0, 0)
      //   console.timeEnd("resize111221耗时")
      // }
      // console.timeEnd("resize耗时")
    },

    // 当前选中学生
    currentStudentHandle (studentItem, studentIndex) {
      if (this.oldStudentId == studentItem.studentId) return
      if (studentItem.questStatus == 1)
        return this.$message.warning(`该学生暂未提交`, 1)
      // this.saveflag1 = true
      // this.handWritingFlag = false
      if (this.currentStudentIndex == -1) {
        this.saveHandWriting()
      }

      this.spinner = true
      this.currentStudentIndex = studentIndex
      this.studentid = studentItem.studentId
      this.studentImg = []
      this.teacherImg = []
      $(".stem-box")
        .find(".stuImg")
        .remove()
      $(".stem-box")
        .find(".teaImg")
        .remove()
      this.getStudentImg()
      this.getTeacherImg()
      this.publicMethods()
    },

    // 获取学生图片
    getStudentImg () {
      this.oldStudentId = this.studentid
      this.$http
        .get(`/v1/learnonly/exercise/single/question`, {
          params: {
            exerciseid: this.$route.query.exerciseId,
            studentid: this.studentid,
            questionorder: this.stem.questIndex,
          },
        })
        .then((res) => {
          if (res.data.code != 200) {
            this.studentImg = []
            this.spinner = false
            this.$message.warning(res.data.message, 1)
            return
          }
          this.studentImg = res.data.data.imgGraphicList//轨迹转绘图出来的学生作答图片
          console.log(this.studentImg)
          this.blankAnswerList =
            typeof res.data.data.blankAnswerList == "string"
              ? JSON.parse(res.data.data.blankAnswerList)
              : res.data.data.blankAnswerList || []
          if (this.stem.mode == 4) {
            this.echoSilentWriting()
          }
          console.log(this.studentImg)
          let quescontent = $(".quescontent").toArray()
          console.log(quescontent)
          for (let i = 0; i < quescontent.length; i++) {
            for (let j = 0; j < this.studentImg.length; j++) {
              if (this.studentImg[j].pages == $(quescontent[i]).attr("pages")) {
                // console.log(this.studentImg[j])
                // console.log($(quescontent[i]))

                if (this.studentImg[j].imgUrl) {
                  this.checkImgWidth(this.studentImg[j].imgUrl).then((res) => {
                    // console.log(res)
                    this.spinner = false
                    let stuImg = res.img
                    stuImg.className = "stuImg"
                    $(stuImg).css({
                      position: "absolute",
                      top: 0,
                      left: 0,
                      zIndex: 99,
                      width: "100%",
                      height: "auto",
                    })
                    this.$nextTick(() => {
                      this.getNewElHeight($(quescontent[i]), res.height)
                      $(quescontent[i]).append(stuImg)
                    })
                  })
                }
              }
            }
          }
        })
        .catch((error) => {
          console.log(error)
          this.studentImg = []
          this.spinner = false
        })
    },

    // 回显默写
    echoSilentWriting () {
      this.spinner = false
      console.log(this.blankAnswerList)
      let bkMode4List = $(".stem-box")
        .find(".bk-mode-4")
        .toArray()
      if (this.blankAnswerList.length > 0 && bkMode4List.length > 0) {
        for (let i = 0; i < bkMode4List.length; i++) {
          for (let j = 0; j < this.blankAnswerList.length; j++) {
            if (
              $(bkMode4List[i]).attr("data-bk-number") ==
              this.blankAnswerList[j].blankIndex
            ) {
              $(bkMode4List[i])
                .siblings()
                .remove()
              $(bkMode4List[i]).val(this.blankAnswerList[j].submitAnswer)
              var rightRate =
                (this.blankAnswerList[j].rightRate * 100).toFixed(0) + "%"
              var rightRateDiv = $('<i class="rightRate silentWriting"></i>')
              rightRateDiv.text(rightRate)
              rightRateDiv.addClass(
                this.getColor(this.blankAnswerList[j].rightRate * 100)
              )
              $(bkMode4List[i]).after(rightRateDiv)
            }
          }
        }
      }
    },

    // 获取教师图片
    getTeacherImg () {
      // console.log(this.stem)
      this.oldStudentId = this.studentid
      this.$http
        .get(`v1/learnonly/exercise/single/question/teacher/correct`, {
          params: {
            exerciseId: this.$route.query.exerciseId,
            studentId: this.studentid,
            questionId: this.stem.questionId,
            classId: this.$route.query.classId,
          },
        })
        .then((res) => {
          // console.log(res)
          if (res.data.code != 200) {
            this.teacherImg = []
            this.spinner = false
            this.$message.warning(res.data.message, 1)
            return
          }
          this.teacherImg = res.data.data
          let quescontent = $(".quescontent").toArray()
          for (let i = 0; i < quescontent.length; i++) {
            for (let j = 0; j < this.teacherImg.length; j++) {
              if (this.teacherImg[j].pages == $(quescontent[i]).attr("pages")) {
                // console.log(this.teacherImg[j])
                // console.log($(quescontent[i]))
                if (this.teacherImg[j].imgUrl) {
                  this.checkImgWidth(this.teacherImg[j].imgUrl).then((res) => {
                    console.log(res)
                    this.spinner = false
                    let teaImg = res.img
                    teaImg.className = "teaImg"
                    $(teaImg).css({
                      position: "absolute",
                      top: 0,
                      left: 0,
                      zIndex: 99,
                      width: "100%",
                      height: "auto",
                    })
                    this.$nextTick(() => {
                      this.getNewElHeight($(quescontent[i]), res.height)
                      $(quescontent[i]).append(teaImg)
                    })
                  })
                }
              }
            }
          }
        })
        .catch((error) => {
          console.log(error)
          this.teacherImg = []
          this.spinner = false
        })
    },

    // 获取后台返回的图片的高度
    checkImgWidth (fileUrl) {
      return new Promise((resolve, reject) => {
        let img = new Image()
        let res = {}

        img.onload = function () {
          res = {
            width: this.width,
            height: this.height,
            img: img,
          }
          resolve(res)
        }
        img.src = fileUrl
      })
    },

    handleLoad () {
      let _this = this
      _this.imgShow = true
      this.spinner = false
    },

    rubbeHandle () {
      this.saveFlag = true
      this.saveflag1 = false
      var data = this.signaturePad.toData()
      if (data) {
        data.pop() // remove the last dot or line
        this.signaturePad.fromData(data)
        if (data.length == 0) {
          this.showHandWriting = false
          this.publicMethods()
        }
      }
    },

    // 滚动到顶部,且删除新加的页,重置canvas的高度
    publicMethods () {
      $(".stem-info").scrollTop(0)
      $(".stem-box .addPages").remove()
      if ($(".stem-info").height() > $(".stem-box").height()) {
        $(".mycanvas")[0].height = $(".stem-info").height()
      } else {
        $(".mycanvas")[0].height = $(".stem-box").height()
      }
    },

    // 清空笔迹
    deleteDrawing () {
      this.saveFlag = true
      this.saveflag1 = false
      this.showHandWriting = false
      this.signaturePad.clear()
      this.publicMethods()
    },

    init () {
      const canvas = $(".mycanvas")[0]
      this.signaturePad = new SignaturePad(canvas, this.config)
      canvas.width = $(".stem-box").width()
      if ($(".stem-info").height() > $(".stem-box").height()) {
        canvas.height = $(".stem-info").height()
        var page = $("<div class='addPages'></div>")
        page.css({
          width: "100%",
          height: $(".stem-info").height() - $(".stem-box").height(),
        })
        $(".stem-box").append(page)
      } else {
        canvas.height = $(".stem-box").height()
      }

      let self = this
      this.signaturePad.onBegin = function () {
        canvas.style.touchAction = "none"
      }

      this.signaturePad.onEnd = function () {
        canvas.style.touchAction = "pan-y"
        self.saveFlag = true
      }
    },

    startWriting () { },

    endWriting () { },

    handleScroll (e) {
      this.newScrollTop = $(e.target).scrollTop()
    },

    //全屏切换
    changeZoom () {
      if (this.isFullDisplay) {

        let contentWidth = $('.stem-info').data("cache_contentWidth")
        let contentMarginLeft = $('.stem-info').data("cache_contentMarginLeft")
        let contentHeight = $('.stem-info').data("cache_contentHeight")


        $('.layout-content').eq(0).css({ 'width': contentWidth, 'margin-left': contentMarginLeft })
        $('.content').css({ 'height': contentHeight })
        $('.header').show()
        $('.answer-info').show()

        $('.stem-info').css({ 'width': '100%' })
        $('.stem-info').css({ 'zoom': this.config.zoom, "overflow-x": "hidden" })

        this.isFullDisplay = false
      } else {
        let contentWidth = $('.layout-content').eq(0).css("width")
        let contentMarginLeft = $('.layout-content').eq(0).css("margin-left")
        let headerHeight = $('.header').outerHeight()
        let contentHeight = $('.content').outerHeight()

        $('.layout-content').eq(0).css({ 'width': '100%', 'margin-left': 0 })
        $('.content').css({ 'height': headerHeight + contentHeight })
        $('.header').hide()
        $('.answer-info').hide()

        //临时存在data里方便下次还原取
        $('.stem-info').data("cache_contentWidth", contentWidth)
        $('.stem-info').data("cache_contentMarginLeft", contentMarginLeft)
        $('.stem-info').data("cache_contentHeight", contentHeight)

        $('.stem-info').css({ 'width': '100%' })
        $('.stem-info').css({ 'zoom': 1.5, "overflow-x": "auto" })

        this.isFullDisplay = true
      }

      //canvas重置...

    },

    //班级管控
    classManage () {
      if (this.isFullDisplay) {
        this.changeZoom()
      }

      let classid = this.$route.query.classId
      this.$router.push("/class/device?classid=" + classid);
    },

    //抽屉
    showDrawer () {
      this.drawerVisible = true
      this.saveHandWriting()
    },

    onClose () {
      this.drawerVisible = false
      this.saveFlag = false
    },

    // 定位题目
    jumpHandle (item, index) {
      if (this.currentStudentIndex != -1) {
        this.saveFlag = false
      }
      // this.saveHandWriting()
      this.drawerVisible = false
      console.log(item)

      if (!item.objective) {
        this.answerChange = false
      }
      this.toggleQuestion = true
      this.subOptionIndex = "0"
      this.studentImg = []
      this.currentStudentIndex = -1
      this.stem = item
      this.questIndex = index
      this.oldStudentId = ""
      this.getQuestionInfo()

      setTimeout(() => {
        this.Redraw()
      }, 0)
    },

    // 重新绘制构建数据
    Redraw () {
      this.getHandWriting()
      this.getQuestionrightRate(
        this.stem.questionId,
        this.stem.objective,
        this.stem.questIndex
      )
      let self = this
      // 判断页面元素图片或音频等资源是否加载完成
      // console.log(document.readyState)
      self.$nextTick(() => {
        word = this.zuoWenWriteWordMin($(".quescontent").text())
        $(".quescontent").each(function () {
          let questindex = Number($(this).attr("initindex"))
          self.paging($(this), questindex)
        })
        self.subjectiveHandle()
        setTimeout(() => {
          $(".quescontent").each(function () {
            self.getNewElHeight($(this))
          })
          // 调用绘制canvas ===============================================================================================================
          this.init()
          this.selectOption()
          this.saveFlag = false
        }, 0)
      })
    },

    // 重置高度
    getNewElHeight ($el, stuImgH) {
      var quescontentList = $(".quescontent").toArray()
      // 把主观题加的页第二页没有学生笔迹的盒子高度置为初始值
      for (let i = 0; i < quescontentList.length; i++) {
        if (!$(quescontentList[i]).find(".stuImg").length > 0) {
          // $(quescontentList[i]).height("auto")
        }
      }
      var childHeight = $($el.find(".child")).prop("scrollHeight")
      var imgHeight = stuImgH ? stuImgH : 0
      $el.css("position", "relative")
      // console.log("$el", $el)
      // console.log("childHeight", childHeight)
      // console.log("imgHeight", imgHeight)
      var questiontype = $el.attr("questiontypename")
      if (questiontype == "作文") {
        var latticePage = $el.find(".latticePage")
        if (latticePage.length > 0) {
          if (!imgHeight || imgHeight == 0) {
            $el[0].style.height = 0
          }
        }
      }
      console.log('===高度', childHeight, imgHeight)
      return
      if (childHeight > imgHeight) {
        // console.log(childHeight)
        $el.height(childHeight)
      } else {
        // console.log(imgHeight)
        $el.height(imgHeight)
      }
    },

    // 分页
    paging ($el, questindex) {
      let devicesDifference = 1
      let self = this
      // if (navigator.userAgent.indexOf("PPR1.180610.011") >= 0) {
      //   // console.log("三星板子")
      //   devicesDifference = 1
      // } else {
      //   devicesDifference = 0
      // }
      self.EL.start_page++
      self.EL.page_count++
      if (self.EL.page_count > self.EL.max_pages) {
        return
      }

      var long = $el.prop("scrollHeight") - Math.ceil($el.innerHeight())
      var innerLong =
        $el.find(".content-box").outerHeight(true) -
        Math.ceil($el.innerHeight())
      // console.log("long", long)
      // console.log("scrollHeight", $el.prop("scrollHeight"))
      // console.log("innerHeight", Math.ceil($el.innerHeight()))
      // self.EL.elHeight = $el.innerHeight()
      var pageTotal = Math.ceil(
        $el[0].scrollHeight / Math.ceil($el.innerHeight())
      )

      $el[0].id = "sq" + "-" + questindex + "-" + self.EL.start_page
      $el.attr("pages", self.EL.start_page)
      $el.attr("quesindex", questindex)

      // 纠证切页小题反转的问题
      if ((long <= devicesDifference && pageTotal == 1) || innerLong <= 0) {
        self.EL.start_page = 0
      }

      var children = $el
        .find(".content-box")
        .children()
        .toArray()
      var removed = []

      while (long > devicesDifference && children.length > 0) {
        var child = children.pop()
        if (child.scrollHeight >= 1066) break;//单个元素的高度超过了分页盒子的高度则跳出
        $(child).detach()
        removed.unshift(child)
        long = $el[0].scrollHeight - Math.ceil($el.innerHeight())
      }

      // console.log("removed", removed)
      if (removed.length > 0) {
        var quescontent = $(
          `<div
        class="quescontent"
        id="sq-${questindex}-${self.EL.start_page}"
        objective="${$el.attr("objective")}"
             pagenum='${self.EL.start_page}'
        questionTypeName="${$el.attr("questionTypeName")}"
        style="position:relative"
				><div class="q-text stem child"><table class="sq"><tbody><tr><td class="sq-num"><span></sapn></td><td class="sq-content content-box-parent"></td></tr></tbody></table></div>
			</div>`
        )
        quescontent.css({
          width: "936px",
          height: "1066px",
          padding: 0,
          margin: 0,
          border: 0,
          position: "relative",
          "box-sizing": "border-box",
        })

        var contentBox = $('<div class="content-box"></div>')
        quescontent.find(".sq-content").append(contentBox)
        contentBox.append(removed)
        $el.after(quescontent)
        // 递归调用创建
        self.paging(quescontent, questindex)

        if (long <= 0 || innerLong <= 0) {
          self.EL.start_page = 0
        }
      }
    },

    // 主观题处理
    subjectiveHandle () {
      let self = this
      $(".quescontent").each(function () {
        let questionTypeName = $(this).attr("questionTypeName")
        let objective = $(this).attr("objective")
        // console.log(objective)
        let questindex = Number($(this).attr("initindex"))
        let pagenum = $(this).attr("pagenum")

        if (objective == "false" || objective == false) {
          // 主观题
          if (questionTypeName == "作文") {
            // 作文题
            if (pagenum == $(".quescontent").length - 1) {
              self.zuowenDrawing($(this), questindex, Number(pagenum))
            }
          } else {
            self.addPage($(this), Number(questindex))
          }
        } else {
          // 客观题
          return
        }
      })
    },

    //作文纸处理
    //作文纸处理
    zuowenDrawing ($el, questindex, pagenum) {
      // console.log($el)
      // console.log(questindex)
      var self = this
      var bg10Node = $(".lattice_bg10").find("img")[0]

      bg10Node.src = require("@/assets/images/exercise-app-bg13.png")
      bg10Node.width = 52
      bg10Node.height = 76

      var fontSize = 24
      var hNum = 17 //10.3平板，一行16字       //列
      var vNum = 14 //行
      var lastword = 0
      // var questionStem = $el[0].outerText
      // var word = self.zuoWenWriteWordMin(questionStem)

      var paperCount = Math.ceil(word / (hNum * vNum)) //作文纸页数
      for (var count = 0; count < paperCount; count++) {
        // 给作文纸加页
        var contentBox, addBox

        contentBox = $(`.quescontent:last`)

        addBox = $(
          `<div class="quescontent"
						id='sq-${questindex}-${pagenum + count + 2}'
						questIndex='${questindex}'
            objective='${$el.attr("objective")}'
            pages='${pagenum + count + 2}'
            pagenum='${pagenum + count + 1}'
						questionTypeName='${$el.attr("questionTypeName")}'
						>
					</div>`
        )

        var writepaper = document.createElement("div")
        writepaper.style.background = "url(" + bg10Node.src + ") repeat"
        writepaper.style.width = hNum * bg10Node.width + "px"
        writepaper.style.height = vNum * bg10Node.height + "px"
        writepaper.style.border = "2px solid #000"
        writepaper.style.position = "relative"
        writepaper.style.margin = "auto auto"
        writepaper.style.top = self.$parent.windowWidth > 1200 ? "1%" : "0"
        writepaper.style.left = self.$parent.windowWidth > 1200 ? "-0.2%" : "0"
        writepaper.style.padding = "0px 0"
        writepaper.style.transform = "translateY(0%)"
        writepaper.className = "latticePage child"
        // 利用闭包防止变量污染 用let也可以解决问题但是板子不支持es6语法
        // 这个打印不能注释,注释掉会出现给作文纸加页错误
        var preventionVariablePollution = (function () {
          function callVariable () {
            for (var i = 0; i < vNum; i++) {
              for (var j = 0; j < hNum; j++) {
                var num = i * hNum + parseInt(j + 1) + lastword
                if (num / 100 == parseInt(num / 100)) {
                  var tip = document.createElement("i")
                  tip.innerHTML = "&nbsp;▲" + num + "字"
                  tip.style.position = "absolute"
                  tip.style.top = (i + 1) * bg10Node.height - 22 + "px"
                  tip.style.left = j * bg10Node.width + "px"
                  tip.style.fontSize = parseInt(fontSize * 0.7) + "px"
                  tip.style.color = "#000"
                  writepaper.appendChild(tip)
                }
              }
            }
          }
          return function () {
            callVariable()
          }
        })()
        preventionVariablePollution()
        lastword += vNum * hNum
        $(addBox).append(writepaper)

        $(contentBox).after(addBox)
      }
    },

    // 获取作文最大字数
    zuoWenWriteWordMin (stem) {
      var reg = new RegExp("(\\d+)字", "gmi")
      var match = stem.match(reg)
      var word = 200
      if (match == null || match == undefined) return word
      if (match.length > 0) {
        word = match[0].replace(reg, "$1")
        if (word.length > 0) {
          word = parseInt(word)
        }
      }
      return parseInt(word * 1.2)
    },

    // 主观题加一页
    addPage ($el, questindex) {
      var self = this
      var contentBox
      self.$nextTick(() => {
        contentBox = self.getContentBox($el, questindex)
        var pages = this.getMaxPages($el, questindex)
        var objective = $el.attr("objective")

        var objectiveDiv = $(
          `<div class="quescontent"
					id='sq-${questindex}-${pages + 1}'
					questIndex='${questindex}'
          objective='${objective}'
          pages='${pages + 1}'
					questionTypeName='${$el.attr("questionTypeName")}'
					>
					<div class="child"></div>
				</div>`
        )

        $(contentBox).after(objectiveDiv)
      })
    },

    // 获取题目分成几页
    getMaxPages ($el, questindex) {
      var quescontentList = $(".quescontent").toArray()
      var pages = 0
      for (var i = 0; i < quescontentList.length; i++) {
        if ($(quescontentList[i]).attr("quesindex") == questindex) {
          pages = $(quescontentList[i]).attr("pages")
        }
      }
      return Number(pages)
    },

    // 获取可以加空白页的前一页
    getContentBox ($el, questindex) {
      if ($(".quescontent").toArray().length > 0) {
        var quescontentList = $(".quescontent").toArray()

        var contentBox = 0
        for (var i = 0; i < quescontentList.length; i++) {
          if ($(quescontentList[i]).attr("quesindex") == questindex) {
            contentBox = $(quescontentList[i])
          }
        }
        return contentBox
      }
    },

    selectOption () {
      let self = this
      $(".stem-box").on("click", ".bk-box", function (e) {
        // 选择小题
        $(this).parents(".stem-box").find(".bk-box").css({'border':'1px dashed #ccc'})
        $(this).css({'border':'1px dashed #f00'})
        self.subOptionIndex = $(this).attr("sub-index")
        self.toggleQuestion = false
      })
    },

    // 获取完对率
    async getQuestionrightRate (questionId, objective, questIndex) {
      const { data: res } = await this.$http.get(
        `v1/learnonly/exercise/statistics/exerciseQuestion/rightRate`,
        {
          params: {
            exerciseId: this.$route.query.exerciseId,
            classId: this.$route.query.classId,
            questionId,
            objective,
            questIndex,
          },
        }
      )
      if (res.code != 200) return this.$message.error(`获取题目数据失败`, 1)
      this.questionList[res.data.questIndex].rightRates = res.data.rightRates
      this.questionList[res.data.questIndex].qrightRate = res.data.rightRate
    },

    questionListSort(sortby){
      if(sortby=="id"){
        return this.questionList.sort((a, b) => a.questIndex - b.questIndex);
      }else{
        return this.questionList.sort((a, b) => b.qrightRate - a.qrightRate);
      }
    },

    handler (component, item) {
      if (item.rightRates && item.rightRates[0].rightRate == "") {
        this.getQuestionrightRate(
          item.questionId,
          item.objective,
          item.questIndex
        )
      }
    },

    // 获取题目列表
    async getQuestionList () {
      const maxWidth = parseInt((936 - 60) * 0.95) // 图片的最大宽度为去掉左边的题目序号,以及图片的最大宽度为95%
      const maxHeight = 1066 - 6 * 24 // 图片的最大高度为留6行fontsize的高度
      const size = 24
      const { data: res } = await this.$http.get(
        `v1/learnonly/exercise/exerciseQuestionList?`,
        {
          params: {
            exerciseId: this.$route.query.exerciseId,
            classId: this.$route.query.classId,
            teacherId: this.$route.query.teacherId,
            size: size, // 传一个固定的字体大小
            width: maxWidth,
            height: maxHeight,
          },
        }
      )
      console.log(res)
      if (res.code != 200) {
        setTimeout(() => {
          this.$router.go(-1)
        }, 1200)
        return this.$message.error(`获取题目数据失败`, 1)
      }
      this.questionList = res.data.questionList
      for (let m = 0; m < this.questionList.length; m++) {
        if (this.questionList[m].mode == 4) {
          this.questionList[m].objective = true
        }
        this.questionList[m].qrightRate = -1
        this.questionList[m].rightRates = [
          {
            bankIndex: "",
            rightRate: "",
          },
        ]
      }
      this.stem = this.questionList[this.questIndex]
      this.getQuestionInfo()
      this.Redraw()
    },
  },

  created () {
    require("@/assets/css/newStyle.less")
    this.getQuestionList()
    // this.getMicrolesson()
    // 手动处理英语默写的题目,mode=4是判断是英语默写题
    if (this.stem.mode == 4) {
      this.stem.objective = false
    }
    for (let i = 0; i < this.questionList.length; i++) {
      if (this.questionList[i].mode == 4) {
        this.questionList[i].objective = false
      }
    }
  },

  mounted () {
    $(".handWritingLoading-box").css({
      "min-width": $(".caret-right-box").width(),
      "text-align": "left",
    })
    $(".page-header-item-2").css({
      "margin-right": -$(".handWritingLoading-box").width(),
    })
    var self = this
    const TikeStyle = document.createElement("style")
    TikeStyle.href = "https://stu.learnonly.com/stylesheets/tike-qstyle.css"
    document.head.appendChild(TikeStyle)

    const MathJax = document.createElement("script")
    MathJax.type = "text/javascript"
    MathJax.src = "https://mathjax.learnonly.com/MathJax.js?config=TeX-MML-AM_SVG"
    document.head.appendChild(MathJax)

    const MLCore = document.createElement("script")
    MLCore.type = "text/javascript"
    MLCore.src = "/resources/MLCore-2016.08.15.min.js?2019050809"
    document.head.appendChild(MLCore)
    self.$nextTick(() => {
      // 缩放题目
      var deviceWidth = $(".stem-info").innerWidth()
      // console.log(deviceWidth)
      var zoom = deviceWidth / 936
      self.config.zoom = zoom
      $(".stem-info").css("zoom", zoom)
      // $(".quescontent").css("min-height", $(".stem-info").height())
      self.zoom = zoom
    })
    window.addEventListener("scroll", self.handleScroll, true)
    $(".bk-mode-4").attr("readonly", "readonly")
  },

  updated () {
    if (window.MathJax) {
      window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub])
      window.MathJax.Hub.Config({
        showProcessingMessages: false, //去加载信息
        messageStyle: "none",
        "HTML-CSS": {
          styles: {
            ".MathJax": {
              outline: 0,
            },
          },
          showMathMenu: false,
          scale: 20,
          undefinedFamily: "serif",
        },
        NativeMML: {
          styles: {
            ".MathJax_SVG": {
              outline: 0,
            },
          },
          showMathMenu: false,
          scale: 20,
          undefinedFamily: "serif",
        },
        SVG: {
          styles: {
            ".MathJax_SVG": {
              outline: 0,
            },
            ".MathJax_SVG svg g, .MathJax_SVG_Display svg g": {
              fill: "#333",
              stroke: "#333",
            },
          },
          showMathMenu: false,
          scale: 20,
          undefinedFamily: "serif",
        },
      })
    }
    if (window.renderLatex) {
      if (this.$refs.contentQ)
        this.$refs.contentQ.forEach((q) => {
          window.renderLatex(q)
        })
    }
  },

  components: {},

  computed: {},

  watch: {
    newScrollTop (newValue, oldValue) {
      setTimeout(() => {
        if (newValue == $(".stem-info").scrollTop()) {
          this.oldScrollTop = newValue //每次滚动结束后都要给oldScrollTop赋值
          // $(".stem-info").css("z-index", "0")
        }
      }, 30) //必须使用延时器，否则每次newValue和window.scrollY都相等，无法判断，20ms刚好大于watch的侦听周期，故延时20ms
      if (this.oldScrollTop == oldValue) {
        //每次滚动开始时oldScrollTop与oldValue相等
        // $(".stem-info").css("z-index", "9999")
      }
    },

    currentStudentIndex (newValue, oldValue) {
      if (oldValue == -1) {
        this.saveFlag = true
        // 如果是点击了隐藏备课笔记,那么点击学生不保存备课笔迹
        if (this.saveflag1) {
          this.saveFlag = false
        }
        // console.log($("mycanvas"))
        // this.saveHandWriting()
      } else {
        this.saveFlag = false
      }

      this.signaturePad.clear()
      $(".stem-info").scrollTop(0)
      // $(".stem-box .addPages").remove()
    },
  },

  directives: {
    // 使用局部注册指令的方式
    resize: {
      // 指令的名称
      bind (el, binding) {
        // el为绑定的元素，binding为绑定给指令的对象
        let width = "",
          height = ""
        function isReize () {
          const style = document.defaultView.getComputedStyle(el)
          if (width !== style.width || height !== style.height) {
            binding.value() // 关键
          }
          width = style.width
          height = style.height
        }
        el.__vueSetInterval__ = setInterval(isReize, 50)
      },
      unbind (el) {
        clearInterval(el.__vueSetInterval__)
      },
    },
  },

  beforeRouteLeave (to, from, next) {
    this.destroyConponents = false
    next()
  },

  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.destroyConponents = true
    })
  },
}
</script>

<style scoped lang="less">
#comments {
  width: calc(100% - 20px);
  height: calc(100vh - 14vh - 20px);
  margin: 10px;
}

.topTitle {
  width: 100%;
  background: #fff;
  margin: 0;
  border-bottom: 2px solid #f0f2f5;
  line-height: 40px;
  display: flex;
  font-size: 16px;
}
.topTitle .return {
  flex: 1;
  padding-left: 10px;
  cursor: pointer;
}
.topTitle .name {
  flex: 11;
  text-align: center;
}
.topTitle .name span {
  font-weight: 700;
}

.topTitle .changeZoom,
.topTitle .quickNavigation,
.topTitle .classManage {
  cursor: pointer;
  color: #409eff;
  margin-right: 20px;
  font-size: 0.9em;
}

.main {
  padding-right: 10px;
  overflow-x: hidden;
  color: #000;
  word-wrap: break-word;
  word-break: normal;
  background-color: #fff;
  // border-bottom: 10px solid #f0f2f5;
}

.main .content {
  width: 100%;
  height: calc(100vh - 14vh - 42px - 20px);
  display: flex;
  justify-content: space-between;
  float: left;
}

.main .content > div {
  overflow: auto;
}

.main .content > .answer-info > .current-answer {
  width: 100%;
  padding: 0 15px;
}

.main .content > .answer-info {
  width: 15%;
  border-right: 10px solid #f0f2f5;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  align-content: flex-start;
  flex-wrap: wrap;
}

.main .content > .answer-info .express {
  display: flex;
  justify-content: space-between; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  flex-wrap: wrap;
  text-align: center;
  margin-bottom: 10px;
}

.main .content > .answer-info .express > div {
  width: 50%;
}

.main .content > .answer-info .express > div > span {
  display: block;
}

.main .content > .answer-info .express > div > i {
  display: inline-block;
  width: 20px;
  height: 20px;
  background-color: #ccc;
}

.main .content > .answer-info .student-info {
  position: relative;
  width: 100%;
  padding: 12px 0px;
  background-color: #fff;
  color: #555;
  border-bottom: 1px solid #dcdfe6;
  display: flex;
  justify-content: space-around;
  cursor: pointer;
}

.main .content > .answer-info .currentStudent {
  color: #1890ff;
}

.main .content > .answer-info .student-info img {
  vertical-align: text-top;
}

.main .content > .answer-info .student-info span {
  flex: 2;
  text-align: left;
}

.main .content > .answer-info .student-info span:first-child {
  flex: 1;
  text-align: right;
  margin-right: 10px;
}

.main .content > .answer-info .student-info:first-child {
  border-top: 1px solid #dcdfe6;
}

.main .content > .answer-info .student-info > i {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  font-size: 20px;
}

.main .content > .answer-info .option {
  width: 100%;
  text-align: center;
  background-color: #1890ff;
  padding: 26px 0px;
  border-radius: 8px;
  color: #fff;
  font-size: 24px;
  margin-bottom: 10px;
}

.main .content > .answer-info .option > div:last-child {
  font-size: 16px;
}

.main .content > .answer-info .studentList > span {
  flex: 1;
}

.main .content > .stem-info {
  width: 80%;
  position: relative;
  font-size: 24px !important;
  border: 0;
  margin: 0;
  padding: 0;
  letter-spacing: 0;
  word-spacing: 0;
  line-height: 40px;
  overflow-x: hidden;
}

.stem-info::-webkit-scrollbar,
.answer-info::-webkit-scrollbar,
.utils::-webkit-scrollbar {
  width: 0;
  overflow: hidden;
}

.bk-ml-l2 span,
.bk-ml-l3 span,
.bk-ml-l4 span {
  height: 74.5px !important;
}

.main .content > .stem-info .stem-box {
  position: relative;
  /* min-height: 100%; */
}

.main .content > .stem-info .stem .sq-num {
  text-align: right;
  vertical-align: top;
  display: block;
  /* 去掉了滚动条的6px的宽度 */
  width: 61px;
}

.main .content > .stem-info .content-box {
  font-family: 'Microsoft-YaHei-Mono';
  font-size: 24px !important;
  width: 875px;
  word-wrap: break-word;
}

.main .content > .stem-info p img {
  // max-width: 95%;
}

.main .content > .stem-info .stem img:not(.Wirisformula) {
  max-width: 936px !important;
  max-height: 922px !important;
  vertical-align: middle;
}

.main .content > .stem-info .stem .content-box img {
  // max-width: 95%;
}

.main .stem-info > .bk-box .rightRate {
  height: 25px;
  line-height: 25px;
  position: absolute;
  top: 0;
  right: 0;
  color: #fff;
  font-size: 16px;
  padding: 0 10px 0 25px;
}

.main .content > .stem-info .stem-box .quescontent {
  width: 936px;
  height: 1066px;
  padding: 0;
  margin: 0;
  border: 0;
  box-sizing: border-box;
  position: relative;
}

.main .content > .stem-info .stem-box .mycanvas {
  position: absolute;
  width: 100%;
  height: auto;
  top: 0;
  left: 0;
  z-index: 999;
}

.main .content > .stem-info .studentImg {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99;
}

.main .content > .stem-info .studentImg > img {
  width: 100%;
}

.main .stem-info .bk-box {
  border: 1px dashed #ccc;
  padding:4.5px 0;
  position: relative;
  z-index: 1001;
}

.main .content > .utils {
  width: 100px;
  //max-height: calc(100vh - 14vh - 42px -20px);
  text-align: center;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  border-left: 10px solid #f0f2f5;
  overflow: hidden;
}

.main .content > .utils > span {
  width: 5vw;
  display: block;
  text-align: center;
  align-items: center;
}

.main .content > .utils > span > img {
  width: 39px;
  height: 39px;
  text-align: center;
  align-items: center;
  margin-left: 24px;
  cursor: pointer;
}

.iconfont {
  width: 5vw;
  font-size: 40px;
  color: #555;
  transition: all 0.1s;
  display: block;
  text-align: center;
  align-items: center;
}

.iconfont:active {
  color: #000000;
}

.main .utils > button.iconfont {
  background-color: #fff;
  cursor: pointer;
}

.rightAnswer {
  max-height: 56vh;
  overflow: auto;
  padding-right: 10px;
  color: #000;
  word-wrap: break-word;
  word-break: normal;
  font-family: 'Microsoft-YaHei-Mono';
}

[v-cloak] {
  display: none;
}

.main .content > .stem-info p {
  margin-bottom: 0;
  word-break: break-word;
}

p {
  margin-bottom: 0;
}

#comments .spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}

.drawerQuestion {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: 'Microsoft-YaHei-Mono';
  margin: 0.5em 0;
}

.drawerQuestion:first-of-type {
  margin-top: 0;
}

.drawerQuestion:last-of-type {
  margin-bottom: 0;
}

.drawerQuestion > div {
  flex: 1;
}

.drawerQuestion > div:nth-child(2) {
  flex: 12;
}

.drawerQuestion > div:nth-child(2) .objectiveQuestion {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  text-align: center;
}

.rightRate {
  width: 15%;
  margin: 5px;
  color: #fff;
  font-size: 16px;
  min-width: 60px;
  display: inline-block;
  text-align: center;
}

.main .stem .Wirisformula {
  vertical-align: middle;
  margin: 0 2px;
  margin-bottom: 3px;
}

.main .stem .silentWriting {
  width: 10%;
  margin-left: -10%;
  height: 24px;
  line-height: 24px;
  color: #fff;
  font-size: 16px;
  min-width: 60px;
  display: inline-block;
  text-align: center;
  vertical-align: top;
}

.main .stem table.english-dictation tr {
  border-top-width: 7px;
}

@media (min-width: 1200px) {
  .iconfont {
    /* font-size: 50px; */
  }

  .main .content > .utils .ant-btn {
    width: 60px;
    height: 60px;
  }

  .main .content > .utils .ant-btn {
    font-size: 24px;
  }

  .main .content > .utils > span {
    width: 50px;
  }

  .main .content > .answer-info .option {
    padding: 20px 0;
    font-size: 34px !important;
    margin-bottom: 16px;
  }

  .main .content > .answer-info .option:last-child {
    margin-bottom: 0;
  }

  .main .content > .stem-info {
    font-size: 24px !important;
  }

  .main .content > .stem-info p,
  .main .content > .stem-info div,
  .main .content > .stem-info span {
    font-size: 24px !important;
  }

  .main .content > .answer-info .option div {
    /* font-size: 30px !important; */
  }

  .main .content > .answer-info .student-info > i {
    font-size: 24px !important;
  }

  .main .stem .silentWriting {
    font-size: 20px;
  }
}
</style>
